import {Icon} from '@components/@icons';
import {Slider} from '@mui/material';
import classNames from 'classnames';
import {MouseEventHandler} from 'react';
import {useVideoPlayer, useVideoPlayerState} from '../../useVideoPlayer';
import {VideoControlsItem} from '../Item/VideoControlsItem';
import styles from './VideoVolumeButton.module.css';

type IProps = {
    setIsVolumeSliderOpen: (isOpen: boolean) => void;
    isVolumeSliderOpen: boolean;
};
export const VideoVolumeButton = ({
    setIsVolumeSliderOpen,
    isVolumeSliderOpen,
}: IProps) => {
    const {toggleMute, setVolume} = useVideoPlayer();

    const isMuted = useVideoPlayerState(s => s.isMuted);
    const volume = useVideoPlayerState(s => s.volume);

    const handleMute: MouseEventHandler<HTMLDivElement> = e => {
        e.stopPropagation();
        toggleMute();
    };

    const maybeUnmute = () => {
        if (isMuted) {
            toggleMute();
        }
    };

    const handleMouseEnter = () => {
        setIsVolumeSliderOpen(true);
    };

    return (
        <VideoControlsItem onMouseEnter={handleMouseEnter}>
            <div className={styles.volumeIcons} onClick={handleMute}>
                {isMuted || volume === 0 ? (
                    <Icon
                        name="volume-mute"
                        color="var(--color-icon-player)"
                        width={24}
                        height={24}
                    />
                ) : (
                    <Icon
                        name="volume-up"
                        color="var(--color-icon-player)"
                        width={24}
                        height={24}
                    />
                )}
            </div>
            <div
                className={classNames(styles.volumeSliderContainer, {
                    [styles.volumeSliderContainerOpen]: isVolumeSliderOpen,
                })}
                onMouseDown={maybeUnmute}
            >
                <Slider
                    size="small"
                    value={isMuted ? 0 : volume * 100}
                    min={0}
                    max={100}
                    className={styles.volumeSlider}
                    onChange={(_, value) => {
                        setVolume((value as number) / 100);
                    }}
                />
            </div>
        </VideoControlsItem>
    );
};
